import { render, staticRenderFns } from "./ClientAttachments.vue?vue&type=template&id=8d97ccc0&"
import script from "./ClientAttachments.vue?vue&type=script&lang=js&"
export * from "./ClientAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports